import type { Variant, Audience } from '../types'

/**
 * Danske labels for funnel + dropoff-widgets. Step-IDs matches what hver flow
 * faktisk emitter til /api/event (chat) hhv. /api/track (calculator).
 *
 * Calculator-step-IDs er ekstraheret fra QUESTIONS-arrayet i:
 *   - public/calculator/index.html         (audience='unge', bil-fokuseret)
 *   - public/calculator-aeldre/index.html  (audience='aeldre', Forsikringstjek
 *                                           bredt-tjek på alle forsikringer)
 * Plus de specielle outcome-events (intro, resultat, thankyou, forsia_stop,
 * over30_stop, under30_stop).
 *
 * Holdes synkroniseret med functions/lib/env.ts CALCULATOR_STEP_ORDER —
 * tilføj samme step-IDs begge steder.
 */

const CHAT_LABELS: Record<string, string> = {
  welcome: 'Navn',
  insurances: 'Forsikringer',
  postnr: 'Postnummer',
  age: 'Alder',
  currentPrice: 'Nuværende pris',
  km: 'Km / år',
  claims: 'Skader',
  phone: 'Telefon',
  consent: 'Samtykke',
  thankyou: 'Færdig',
}

const CALCULATOR_UNGE_LABELS: Record<string, string> = {
  intro: 'Start',
  bil_status: 'Har bilforsikring i dag?',
  alder: 'Alder',
  bil_type: 'Biltype',
  maanedlig_praemie: 'Månedlig præmie',
  selskab: 'Forsikringsselskab',
  resultat: 'Resultat',
  thankyou: 'Lead indtastet',
  forsia_stop: 'Stop: Allerede hos Forsia',
  over30_stop: 'Stop: Over 30 år',
}

const CALCULATOR_AELDRE_LABELS: Record<string, string> = {
  intro: 'Start',
  alder: 'Aldersgruppe',
  husstand: 'Husstand',
  hjem: 'Boligforsikringer',
  koeretoej: 'Motorkøretøjer',
  person: 'Helbredsforsikringer',
  selskab: 'Forsikringsselskab',
  maanedlig_praemie: 'Månedlig præmie',
  tilfredshed: 'Anciennitet hos selskab',
  resultat: 'Resultat',
  thankyou: 'Lead indtastet',
  forsia_stop: 'Stop: Allerede hos Forsia',
  under30_stop: 'Stop: Under 30 år',
}

/**
 * Når admin filtrerer "alle audiences" har vi ikke nok kontekst til at
 * vælge unge- eller aeldre-labels. Falder tilbage på unionen — duplikater
 * (`alder`, `selskab`, `maanedlig_praemie`) er identiske mellem audiences,
 * så fallback'en er semantisk korrekt for alle delte step-IDs.
 */
const CALCULATOR_LABELS_UNION: Record<string, string> = {
  ...CALCULATOR_UNGE_LABELS,
  ...CALCULATOR_AELDRE_LABELS,
}

export function stepLabel(variant: Variant, step: string, audience?: Audience): string {
  if (variant === 'chat') return CHAT_LABELS[step] ?? step
  if (audience === 'unge') return CALCULATOR_UNGE_LABELS[step] ?? step
  if (audience === 'aeldre') return CALCULATOR_AELDRE_LABELS[step] ?? step
  return CALCULATOR_LABELS_UNION[step] ?? step
}
